import dayjs from 'dayjs';

export const duration = (months) => {
    if (months < 12) {
        return `${months} Month`;
    }

    return `${months / 12} Year`;
};

export function GetDate(timeStamp) {
    if (!timeStamp) {
        return null;
    }
    const dateFormat = dayjs(timeStamp * 1000).format(`DD ${`MMMM`.slice(0, 3)} YYYY`);
    return dateFormat.toString() !== 'Invalid Date' ? dateFormat : '--';
}
export function GetMonthYear(timeStamp) {
    if (!timeStamp) {
        return null;
    }
    const dateFormat = dayjs(timeStamp * 1000).format(`MMM YYYY`);
    return dateFormat.toString() !== 'Invalid Date' ? dateFormat : '--';
}

// Get Valid Till Date
export function GetValidTillDate(timeStamp, validity) {
    if (!timeStamp) {
        return null;
    }
    const dateFormat = dayjs(timeStamp * 1000)
        .add(validity, 'day')
        .format(`DD MMM YYYY`);
    return dateFormat.toString() !== 'Invalid Date' ? dateFormat : '--';
}
// Get Date with "2023-01-29T08:35:19Z"
export function GetDateFromISO(params) {
    if (!params) {
        return null;
    }
    const dateFormat = dayjs(params).format(`DD ${`MMMM`.slice(0, 3)} YYYY`);
    return dateFormat.toString() !== 'Invalid Date' ? dateFormat : '--';
}
export function GetDateFromISOWithTime(params) {
    if (!params) {
        return null;
    }
    const dateFormat = dayjs(params).format(`DD ${`MMMM`.slice(0, 3)} YYYY h:mm:ss A`);
    return dateFormat.toString() !== 'Invalid Date' ? dateFormat : '--';
}
export function GetTime(timeStamp) {
    if (!timeStamp) {
        return null;
    }
    const dateFormat = dayjs(timeStamp * 1000).format('h:mm:ss A');
    return dateFormat.toString() || null;
}

export function GetDateTime(timeStamp) {
    if (!timeStamp) {
        return null;
    }
    const dateFormat = dayjs(timeStamp * 1000).format('DD MMM YYYY h:mm:ss A');
    return dateFormat.toString() || null;
}

export function GetInvoiceDate(timeStamp) {
    return dayjs(timeStamp * 1000).format('DD.MM.YYYY');
}

export const getDayDiff = (timestamp) => {
    const currentDate = dayjs();
    const expireDate = dayjs(timestamp * 1000);

    if (!timestamp) {
        return null;
    }

    return expireDate?.diff(currentDate, 'd');
};

// file size display
export const GetFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / k ** i).toFixed(2))} ${sizes[i]}`;
};

export const GetFileTypeToFull = (filename) => {
    const fileNameArr = [
        { type: 'pdf', title: 'Adobe PDF file' },
        {
            type: 'vnd.openxmlformats-officedocument.wordprocessingml.document',
            title: 'Office text document'
        },
        { type: 'msword', title: 'Office text document' },
        { type: 'xml', title: 'Office text document' },
        {
            type: 'vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            title: 'Office text document'
        },
        { type: 'vnd.ms-excel', title: 'Office spreadsheet document' },
        { type: 'xlsx', title: 'Office spreadsheet document' },
        { type: 'csv', title: 'Office spreadsheet document' },
        { type: 'plain', title: 'Text Document' },
        { type: 'x-compressed', title: 'Archive File' },
        { type: 'x-7z-compressed', title: 'Archive File' },
        { type: 'x-zip-compressed', title: 'Archive File' },
        { type: 'png', title: 'Image File' },
        { type: 'jpg', title: 'Image File' },
        { type: 'jpeg', title: 'Image File' },
        { type: 'gif', title: 'Image File' },
        { type: 'svg+xml', title: 'Image File' },
        { type: 'audio', title: 'Audio File' },
        { type: 'mpeg', title: 'Audio File' },
        { type: 'mp3', title: 'Audio File' },
        { type: 'wav', title: 'Audio File' },
        { type: 'ogg', title: 'Audio File' },
        { type: 'mp4', title: 'Video File' },
        { type: 'mov', title: 'Video File' },
        { type: 'avi', title: 'Video File' },
        { type: 'mkv', title: 'Video File' }
    ];
    const fileExtension = filename.split('/').pop();
    const file = fileNameArr.find((i) => i.type === fileExtension);
    return file?.title || 'Unknown File Type';
};
export const getFileType = (fileLink) => {
    const fileExtension = fileLink.split('.').pop().toLowerCase();
    return fileExtension;
};
